import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("D:/Github/oxbull-web-5-edge/layouts/app.vue")),
  blinkproject: defineAsyncComponent(() => import("D:/Github/oxbull-web-5-edge/layouts/blinkproject.vue")),
  default: defineAsyncComponent(() => import("D:/Github/oxbull-web-5-edge/layouts/default.vue")),
  home: defineAsyncComponent(() => import("D:/Github/oxbull-web-5-edge/layouts/home.vue")),
  landing: defineAsyncComponent(() => import("D:/Github/oxbull-web-5-edge/layouts/landing.vue")),
  project: defineAsyncComponent(() => import("D:/Github/oxbull-web-5-edge/layouts/project.vue"))
}